// src/services/api/index.ts
import { authApi } from './auth';
import { productsApi } from './products';
import { categoriesApi } from './categories';
import { sellersApi } from './sellers';
import { cartApi } from './cart';
import { ordersApi } from './orders';
// Exportar todas las APIs
export { authApi } from './auth';

export { productsApi } from './products';
export { categoriesApi } from './categories';
export { sellersApi } from './sellers';
export { cartApi } from './cart';
export { ordersApi } from './orders';

// Exportar el cliente HTTP para casos especiales
export { httpClient } from '@/services/http/client';

// Objeto unificado para acceso fácil a todas las APIs
export const api = {
    auth: authApi,
    products: productsApi,
    categories: categoriesApi,
    sellers: sellersApi,
    cart: cartApi,
    orders: ordersApi,
} as const;

// Tipos de respuesta para conveniencia
export type * from '@/services/types/api';
export type * from '@/services/types/domain';

// Para compatibilidad con el código existente
export const productsService = {
    // Productos
    getProducts: productsApi.getProducts.bind(productsApi),
    getFeaturedProducts: productsApi.getFeaturedProducts.bind(productsApi),
    searchProducts: productsApi.searchProducts.bind(productsApi),
    getProductById: productsApi.getProductById.bind(productsApi),
    getProductBySlug: productsApi.getProductBySlug.bind(productsApi),
    getProductsByCategory: productsApi.getProductsByCategory.bind(productsApi),
    getRelatedProducts: productsApi.getRelatedProducts.bind(productsApi),
    createProduct: productsApi.createProduct.bind(productsApi),
    updateProduct: productsApi.updateProduct.bind(productsApi),
    deleteProduct: productsApi.deleteProduct.bind(productsApi),
    uploadProductImages: productsApi.uploadProductImages.bind(productsApi),
    checkStock: productsApi.checkStock.bind(productsApi),
    getProductReviews: productsApi.getProductReviews.bind(productsApi),
    getProductReviewStats: productsApi.getProductReviewStats.bind(productsApi),
    createReview: productsApi.createReview.bind(productsApi),
    markReviewHelpful: productsApi.markReviewHelpful.bind(productsApi),
    getMyProducts: productsApi.getMyProducts.bind(productsApi),
    generateSKU: productsApi.generateSKU.bind(productsApi),
    validateImages: productsApi.validateImages.bind(productsApi),

    // Categorías
    getCategories: categoriesApi.getCategories.bind(categoriesApi),
    getPopularCategories: categoriesApi.getPopularCategories.bind(categoriesApi),
    getCategoryById: categoriesApi.getCategoryById.bind(categoriesApi),
    getCategoryBySlug: categoriesApi.getCategoryBySlug.bind(categoriesApi),
    searchCategories: categoriesApi.searchCategories.bind(categoriesApi),

    // Vendedores
    registerAsSeller: sellersApi.registerAsSeller.bind(sellersApi),
    getSellerProfile: sellersApi.getSellerProfile.bind(sellersApi),
    updateSellerProfile: sellersApi.updateSellerProfile.bind(sellersApi),
    getSellerDashboard: sellersApi.getSellerDashboard.bind(sellersApi),
    getPublicSellerInfo: sellersApi.getPublicSellerInfo.bind(sellersApi),
    getSellerProducts: sellersApi.getSellerProducts.bind(sellersApi),
};

// Re-exportar para compatibilidad
export default productsService;